import React from 'react';
import { extend } from '@thd-nucleus/data-sources';
import { MediaHotspots } from '@thd-olt-component-react/product-hotspots';

import { MediaGalleryDesktopHorizontal } from './MediaGalleryDesktopHorizontal';
import { dataModel, hotspotsMediaDataModel } from './dataModel';
import { mediaGalleryDesktopPropTypes } from './MediaGalleryPropTypes';

export const MediaGalleryHorizontalWithHotspots = (props) => {
  return (
    <MediaGalleryDesktopHorizontal {...props} />
  );
};

MediaGalleryHorizontalWithHotspots.displayName = 'MediaGalleryHorizontalWithHotspots';

MediaGalleryHorizontalWithHotspots.propTypes = mediaGalleryDesktopPropTypes;

MediaGalleryHorizontalWithHotspots.dataModel = extend({}, hotspotsMediaDataModel, dataModel, MediaHotspots);
